<template>
    <div id="input-page">
        <customer-search
            :config="customers"
            :action="createOrder"
        />
        <br />
        <br />
        <customer-search
            :config="serviceOrderCustomers"
            :action="createServiceOrder"
        />
    </div>
</template>
<script>
import SpinnerText from '../components/loader/SpinnerText';
import CustomerSearch from '../components/customers/CustomerSearch';
import orderApi from '../api/order';
import { showErrorMessage } from '../dialogs';
import localization from '../mixins/localization';

export default {
    components: { CustomerSearch, SpinnerText },
    mixins: [localization],
    data() {
        const placeholders = {
            customerId: this.trans('pages.input_page.placeholders.customer_id'),
            name: this.trans('pages.input_page.placeholders.name'),
            productId: this.trans('pages.input_page.placeholders.product_id'),
        };
        return {
            customers: {
                title: this.trans('pages.input_page.order_customer_select'),
                key: 'customers',
                items: null,
                loading: false,
                loadingLabel: this.trans('pages.input_page.loading_customers'),
                fields: {
                    customerId: '',
                    name: '',
                },
                placeholders,
            },
            serviceOrderCustomers: {
                title: this.trans(
                    'pages.input_page.service_order_customer_select'
                ),
                key: 'serviceOrderCustomers',
                items: null,
                loading: false,
                loadingLabel: this.trans('pages.input_page.loading_customers'),
                fields: {
                    customerId: '',
                    name: '',
                    productId: '',
                },
                placeholders,
            },
        };
    },
    methods: {
        createOrder(customer) {
            orderApi
                .createOrder(customer.customerId)
                .then((response) => {
                    this.$router.push(
                        '/editproduct/?orderId=' +
                            response.data.data.orderId +
                            '&productState=show-producttype'
                    );
                })
                .catch(() => {
                    showErrorMessage(
                        this.trans('pages.input_page.create_order_failed')
                    );
                });
        },
        createServiceOrder(customer) {
            orderApi
                .createServiceOrder(customer.customerId)
                .then((response) => {
                    this.$router.push(
                        '/editproduct/?orderId=' +
                            response.data.data.orderId +
                            '&productState=show-producttype'
                    );
                })
                .catch(() => {
                    showErrorMessage(
                        this.trans(
                            'pages.input_page.create_service_order_failed'
                        )
                    );
                });
        },
    },
};
</script>
